import React from 'react';
import _ from 'lodash';
import ProjectDetail from '../screens/ProjectDetail';
import LanguageList from '../screens/LanguageList';
import LanguageForm from '../screens/LanguageForm';
import ProjectForm from '../screens/ProjectForm';
import LabelCollectionForm from '../screens/LabelCollectionForm';
import LabelCollectionDetail from '../screens/LabelCollectionDetail';
import LabelForm from '../screens/LabelForm';
import Engine from '../screens/Engine';
import ExportProject from '../screens/ExportProject';
import ImportProject from '../screens/ImportProject';
import {Route} from 'react-router-dom';
import {matchPath} from "react-router-dom";
import CodeScanner from "../screens/CodeScanner";

export const renderScreenRoutes = () => {
	return _.map(routes, (route, key) => {
		return <Route path={route.path} component={route.component} key={key} exact={true}/>
	});
};

export const getParamsByLocation = (location) => {
	let params = {};
	routes.forEach(route => {
		const match = matchPath(location.pathname, {path: route.path, exact: true});
		if(match){
			params = match.params;
		}
	});

	return params;
};

const routes = [
	{
		path: '/engine',
		component: Engine
	},
	{
		path: '/show/:project',
		component: ProjectDetail
	},
	{
		path: '/create-project',
		component: ProjectForm
	},
	{
		path: '/edit/:project',
		component: ProjectForm
	},
	{
		path: '/languages',
		component: LanguageList,

	},
	{
		path: '/create-language',
		component: LanguageForm
	},
	{
		path: '/edit-language/:language',
		component: LanguageForm
	},
	{
		path: '/show/:project/:labelCollection',
		component: LabelCollectionDetail
	},
	{
		path: '/edit/:project/:labelCollection',
		component: LabelCollectionForm
	},
	{
		path: '/create-labelCollection/:project',
		component: LabelCollectionForm
	},
	{
		path: '/create-label/:project/:labelCollection',
		component: LabelForm
	},
	{
		path: '/edit/:project/:labelCollection/:label',
		component: LabelForm
	},
	{
		path: '/export-project/:project',
		component: ExportProject
	},
	{
		path: '/import-project/:project',
		component: ImportProject
	},
	{
		path: '/code-Scanner/:project',
		component: CodeScanner
	}
];



// WEBPACK FOOTER //
// ./React/src/services/routing.js